import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Text, Alert, Space, Paper, Title, Table, Badge, Group, Stack } from '@mantine/core';
import { AlertTriangle, ListChecks, MapPin, Building, Tag as TagIcon, Ruler, BarChart3 } from 'lucide-react';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { initialAgentPriceDefault } from '../../data';

interface SellingStudyPanelProps {}

interface Listing {
  id: number;
  title: string;
  area: string;
  price: string;
  size: number;
  tags: string[];
  notes: string;
  communityName?: string;
  isRented?: boolean;
  url: string;
}

const listingsData: Listing[] = [
  {
    id: 1,
    title: "荔灣黃沙（西城都薈 喜茶商舖）46.8萬買斷產權 月租1萬7",
    area: "37.5m²",
    price: "46.8萬",
    size: 37.5,
    tags: ["臨街門面", "可餐飲", "帶租約"],
    communityName: "黃沙· 西城都薈",
    notes: "面積與目標物業完全一致。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7134335953/?from=Biz_list&uniqid=8c62790fda6343e8adf13438b4a4b87d&isauction=1",
  },
  {
    id: 2,
    title: "荔灣沙面島網紅旅遊景點！臨街便利店（總價140萬 獨立紅本）",
    area: "40m²",
    price: "140萬",
    size: 40,
    tags: ["臨街門面", "可明火"],
    communityName: "沙面· 沙面街",
    notes: "熱門旅遊景點，人流量可能較大。",
    isRented: false,
    url: "https://m.anjuke.com/gz/sp/shou/7115989638/?from=Biz_list&uniqid=dde2a31a6e8c4afa82ebc479a607e4e2&isauction=2",
  },
  {
    id: 3,
    title: "荔灣老市區地鐵口 領展廣場 喜茶旺舖 收租1萬9！",
    area: "30m²",
    price: "36萬",
    size: 30,
    tags: ["臨街門面", "可餐飲", "帶租約"],
    communityName: "黃沙· 西城都薈",
    notes: "地鐵口商舖，租金較高。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7114207921/?from=Biz_list&uniqid=a11f9959c96443faa4af398562153a63&isauction=1",
  },
  {
    id: 4,
    title: "（產權商舖）中山八路一點點 收租1萬2 馬上過戶",
    area: "40m²",
    price: "100萬",
    size: 40,
    tags: ["臨街門面", "可餐飲", "帶租約"],
    communityName: "南岸· 中山八路商舖",
    notes: "知名連鎖品牌入駐。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7124230317/?from=Biz_list&uniqid=afc2b8d98880430cbf92e4fa52c4399b&isauction=1",
  },
  {
    id: 5,
    title: "個人原因急售 西城都薈商舖 霸王茶姬 收租2萬5",
    area: "36m²",
    price: "100萬",
    size: 36,
    tags: ["購物百貨中心", "可餐飲", "帶租約"],
    communityName: "黃沙· 西城都薈",
    notes: "位於大型購物中心，人流有保障。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7115909815/?from=Biz_list&uniqid=eddd49c5cdf54902bb19e2637a50e0dd&isauction=1",
  },
  {
    id: 6,
    title: "賣斷！西城都薈 地鐵口帶租一萬五 無抵押 超55萬！",
    area: "45m²",
    price: "55萬",
    size: 45,
    tags: ["商業街店舖", "可餐飲", "帶租約"],
    communityName: "荔灣路· 西城都薈",
    notes: "價格相對較低，且近地鐵口。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7068156205/?from=Biz_list&uniqid=ece5f32fd44140a1a146aeffc787ea98&isauction=1",
  },
  {
    id: 7,
    title: "（帶不動產權）荔灣珠江旁（臨街租約3年）帶租1萬3",
    area: "38m²",
    price: "4.5萬",
    size: 38,
    tags: ["臨街門面", "可餐飲", "帶租約"],
    communityName: "橋中· 西郊商貿中心",
    notes: "價格極低，但需注意產權問題。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7111948395/?from=Biz_list&uniqid=1e50245753e14add813f6058ef0a0eee&isauction=1",
  },
  {
    id: 8,
    title: "（芳村）地鐵口（帶租15000） 紅本過戶 臨街門面 急售",
    area: "50m²",
    price: "200萬",
    size: 50,
    tags: ["購物百貨中心", "臨街", "帶租約"],
    communityName: "西塱· 芳村國際商業廣場",
    notes: "芳村區域，近地鐵，面積較大。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7078620419/?from=Biz_list&uniqid=eab07431cb924187a80426e1af8f3c0a&isauction=1",
  },
  {
    id: 9,
    title: "荔灣中山八路！一線臨街（獨立房產證）現租一點點月收11000",
    area: "25m²",
    price: "19.8萬",
    size: 25,
    tags: ["臨街門面", "可餐飲", "帶租約"],
    communityName: "南岸· 中山八路商舖",
    notes: "小面積，總價低，有獨立產權。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7000179182/?from=Biz_list&uniqid=dc72a2aca019417cb748ae8511c50b0f&isauction=1",
  },
  {
    id: 10,
    title: "廣州中山八！一點點筍舖出售總價58.8w月收租13000！",
    area: "40m²",
    price: "58.8萬",
    size: 40,
    tags: ["臨街門面", "可餐飲", "帶租約"],
    communityName: "長壽路· 中山八路小區中山八路商舖",
    notes: "價格適中，位於成熟商圈。",
    isRented: true,
    url: "https://m.anjuke.com/gz/sp/shou/7033639605/?from=Biz_list&uniqid=167d64d0218d48df92cb2f6b7d687c31&isauction=1",
  },
  {
    id: 11,
    title: "廣州市荔灣區芳村, 小區內商舖, 37.5m², 小區內，非臨街，非地鐵附近, 目前用途：出租中。",
    area: "37.5m²",
    size: 37.5,
    price: "1.3百萬",
    tags: ["小區內舖", "可餐飲", "帶租約"],
    communityName: "芳村· 芳村",
    notes: "目標物業（本報告分析對象）",
    isRented: true,
    url: "#",
  }
].sort((a, b) => a.size - b.size);

const SellingStudyPanel: React.FC<SellingStudyPanelProps> = () => {
  const rows = listingsData.map((listing) => (
    <Table.Tr key={listing.id}>
      <Table.Td>
        <Text fw={500} component="a" href={listing.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
          {listing.title}
        </Text>
        {listing.communityName && (
          <Text size="xs" c="dimmed"><Building size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />{listing.communityName}</Text>
        )}
        <Text size="xs" c="dimmed" mt={4}>{listing.notes}</Text>
         {listing.isRented && <Badge color="teal" variant="light" mt="xs">帶租約</Badge>}
      </Table.Td>
      <Table.Td>
        <Group gap="xs" align="center">
            <Ruler size={16} /> <Text>{listing.area}</Text>
        </Group>
      </Table.Td>
      <Table.Td><Text fw={500} c="blue">{listing.price}</Text></Table.Td>
      <Table.Td>
        {listing.tags.map(tag => (
          <Badge key={tag} variant="light" color="gray" mr={4} mb={4} leftSection={<TagIcon size={12}/>}>{tag}</Badge>
        ))}
      </Table.Td>
    </Table.Tr>
  ));

  const chartData = listingsData.map(listing => ({
    area: parseFloat(listing.area.replace('m²', '')),
    price: parseFloat(listing.price.replace('萬', '').replace('百萬', '')),
    name: listing.title,
  }));

  const ourPropertyData = {
    area: 37.5,
    price: initialAgentPriceDefault,
    name: '本物業 (中介建議價)',
  };
  
  return (
    <Stack gap="lg">
      <Card>
        <CardHeader>
          <CardTitle>
            <Group>
              <ListChecks /> 賣盤研究 (Comparable Sales Study)
            </Group>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Text mb="md">
            以下為在廣州市荔灣區找到的與目標物業（小區內舖, 37.5m², 非臨街, 非地鐵口）類似的在售商舖信息。
            數據來源於安居客（Anjuke.com）並根據現有信息進行了初步篩選。
          </Text>
          
          {listingsData.length > 0 ? (
            <Paper shadow="xs" p="md" withBorder>
              <Table striped highlightOnHover withColumnBorders>
                <Table.Thead>
                  <Table.Tr>
                    <Table.Th>物業描述</Table.Th>
                    <Table.Th>面積</Table.Th>
                    <Table.Th>價格</Table.Th>
                    <Table.Th>標籤</Table.Th>
                  </Table.Tr>
                </Table.Thead>
                <Table.Tbody>{rows}</Table.Tbody>
              </Table>
            </Paper>
          ) : (
            <Alert icon={<AlertTriangle size={16} />} title="未能找到完全匹配的房源" color="orange" radius="md" p="lg">
              <Text>
                根據指定的嚴格標準（小區內、非臨街、非地鐵口、約37.5m²），在荔灣芳村區域未能通過自動搜索找到足夠數量的精確匹配房源。
                以上列表可能包含部分接近的房源，或建議放寬部分搜索條件。
              </Text>
            </Alert>
          )}
          
          <Space h="lg" />
          <Text size="sm" c="dimmed">
            <MapPin size={14} style={{ marginRight: 4, verticalAlign: 'middle' }}/>目標物業: 廣州市荔灣區芳村, 小區內舖, 37.5m², 小區內，非臨街，非地鐵附近, 目前用途：出租中。
          </Text>
          <Text size="xs" c="dimmed" mt={4}>
            免責聲明：以上數據僅供參考，請以實際房源信息和最終合同為準。部分物業特性（如"非臨街"、"非地鐵附近"）基於標籤和標題推斷，建議實地核實。房源鏈接已更新為真實鏈接，點擊標題可跳轉至詳情頁。
          </Text>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>
            <Group>
              <BarChart3 size={20} /> 荔灣區可比物業售價與面積關係圖
            </Group>
          </CardTitle>
        </CardHeader>
        <CardContent pt="md">
          <Text mb="md">
            下圖展示了搜集到的荔灣區20-50m²在售商舖的價格與面積關係。
            價格單位為"萬人民幣"。圖中也包含了本報告分析的目標物業（37.5m²，當前業主報價）作為對比。
            請注意，實際成交價受多種具體因素影響，圖示僅供參考。
          </Text>
          <Paper h={350} p="sm" withBorder>
            <ResponsiveContainer width="100%" height="100%">
              <ScatterChart
                margin={{
                  top: 20, right: 30, bottom: 20, left: 20,
                }}
              >
                <CartesianGrid />
                <XAxis 
                  type="number" 
                  dataKey="area" 
                  name="面積" 
                  unit="㎡" 
                  domain={['dataMin - 2', 'dataMax + 2']} 
                  tickFormatter={(value) => String(Math.round(value))}
                />
                <YAxis 
                  type="number" 
                  dataKey="price" 
                  name="價格" 
                  unit="萬" 
                  domain={['dataMin - 10', 'dataMax + 10']}
                  tickFormatter={(value) => String(Math.round(value))}
                />
                <Tooltip 
                  cursor={{ strokeDasharray: '3 3' }} 
                  formatter={(value: any, name: any, entry: any) => {
                    const payloadName = entry.payload.name || 'Unknown Listing';
                    if (name === 'area') return [entry.payload.area + '㎡', payloadName ];
                    if (name === 'price') return [entry.payload.price + '萬', '價格'];
                    return [value, name];
                  }}
                  labelFormatter={(label, payload) => {
                     if (payload && payload.length > 0 && payload[0] && payload[0].payload && payload[0].payload.name) {
                       return payload[0].payload.name;
                     }
                     return '';
                  }}
                />
                <Legend />
                <Scatter name="市場掛牌可比物業" data={chartData} fill="#8884d8" />
                <Scatter name="本物業 (業主報價)" data={[ourPropertyData]} fill="#d0ed57" shape="star" />
              </ScatterChart>
            </ResponsiveContainer>
          </Paper>
          <Title order={5} mt="lg" mb="sm">圖表解讀：</Title>
          <Text>
            從圖表數據來看，本物業37.5m²的報價（${ourPropertyData.price.toFixed(1)}萬）在市場上屬於中等偏上水平。
            有部分面積相似或稍大的物業報價較低，但也有面積較小或相似的物業報價更高。
            例如，同樣位於西城都薈的一個30m²的物業報價為36萬，而另一個36m²的物業報價高達100萬。
            價格差異可能源於具體位置、樓層、裝修、租約情況及物業類型（如是否為購物中心內舖位、是否可餐飲等）等多種因素。
            本物業的定價策略需結合其具體優勢和市場定位綜合考量。
          </Text>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default SellingStudyPanel; 